import type React from 'react';
import type { JSX } from 'react';

import clsx from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// `underline-link` is a plugin utility, so twMerge must be told a caller's `no-underline` replaces it.
const twMerge = extendTailwindMerge({ extend: { classGroups: { 'text-decoration': ['underline-link'] } } });

export const BaseFontFeatureSettings = "'case' on, 'ss04' on";
export const NumberFontFeatureSettings = "'tnum' on, 'lnum' on, 'case' on";

interface TextLinkProps extends React.HTMLAttributes<HTMLSpanElement> {
    children: React.ReactNode;
    color?: string;
    className?: string;
    href?: string;
    newTab?: boolean;
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const makeTextLinkElement =
    (twClasses: string) =>
    ({
        children,
        href = undefined,
        onClick,
        newTab,
        color = 'inherit',
        className,
        ...props
    }: TextLinkProps): JSX.Element => {
        const combinedClassName = twMerge(clsx(twClasses, className));
        const style: React.CSSProperties = { color };

        return href === '' ? (
            <span
                onClick={onClick}
                style={{ ...style, cursor: !!onClick ? 'pointer' : undefined }}
                className={combinedClassName}
                {...props}
            >
                {children}
            </span>
        ) : (
            <a
                href={href}
                style={{ ...style, cursor: 'pointer' }}
                className={combinedClassName}
                {...(newTab ? { target: '_blank', rel: 'noopener noreferrer' } : undefined)}
                onClick={onClick}
                {...props}
            >
                {children}
            </a>
        );
    };

export default {
    Link: {
        x10: makeTextLinkElement('typ-body-x10 font-normal underline-link'),
        x20: makeTextLinkElement('typ-body-x20 font-normal underline-link'),
        x30: makeTextLinkElement('typ-body-x30 font-normal underline-link'),
    },
};
